import haptics from "@helpers/haptics"
import { useState } from "react"
import { twMerge } from "tailwind-merge"

interface RadioCardProps {
  className?: string
  emoji?: string
  label: string
  description?: string
  name: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  value: string
  defaultChecked?: boolean
  optionKey?: string
}

export default function RadioCard({
  className = "",
  emoji,
  label,
  description,
  name,
  onChange,
  value,
  defaultChecked = false,
  optionKey,
}: RadioCardProps) {
  const [isChecked, setIsChecked] = useState(defaultChecked)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    haptics.trigger("selection")
    setIsChecked(event.target.checked)
    onChange(event)
  }

  return (
    <label
      className={twMerge(
        "bg-card flex cursor-pointer items-center gap-4 rounded-2xl border-2 px-6 py-5 transition-all duration-200",
        isChecked
          ? "bg-card border-white/30"
          : "hover:bg-card-hover border-gray-700/50 hover:border-gray-600/50",
        className,
      )}
    >
      <input
        className="hidden"
        name={name}
        onChange={handleChange}
        type="radio"
        value={value}
        defaultChecked={defaultChecked}
        data-option-key={optionKey}
      />

      {/* Icon Container */}
      {emoji && (
        <div className="bg-card-elevated flex h-14 w-14 shrink-0 items-center justify-center rounded-xl p-2">
          <span className="emoji text-3xl leading-none">{emoji}</span>
        </div>
      )}

      {/* Text Content */}
      <div className="flex flex-col gap-1">
        <span className="text-text-primary font-semibold">{label}</span>
        {description && (
          <span className="text-text-secondary text-sm">{description}</span>
        )}
      </div>
    </label>
  )
}
